@if (data.parent == 'oppty-list') {
  <h1 mat-dialog-title>Edit Opportunity</h1>
}
@if (data.parent == 'dx-list') {
  <h1 mat-dialog-title>Edit Diagnosis Event</h1>
}

<div mat-dialog-content [overlayLoading]="loading">
  <div class="content-container flex flex-col">

    <div class="grid grid-cols-8 gap-2">
      @if (data.mode == 'batch') {
        <div class="flex flex-auto flex-col col-start-1 col-span-8">
          <h2>Edit @if (!canEditAllResults) {
            <strong>{{data.items.length}}</strong>
          } Selected Opportunities</h2>
          @if (!canEditAllResults) {
            <label style="padding: 0 0 0 15px">Current Status Count: {{batchStatusStats}}</label>
          }
          @if (!canEditAllResults) {
            <label style="padding: 0 0 0 15px">Current Preferred Action Count: {{batchPreferredActionStats}}</label>
          }
        </div>
      }

      @if (canEditAllResults) {
        <div class="flex flex-auto col-start-1 col-span-4">
          <mat-radio-group [formControl]="batchTypeControl" class="flex flex-auto flex-col gap-[5px]">
            <mat-radio-button [value]="'default'"><strong>{{data.items.length | number}}</strong> records from the page</mat-radio-button>
            <mat-radio-button [value]="'all'"><strong>{{data.queryResultCount | number}}</strong> records from results</mat-radio-button>
          </mat-radio-group>
        </div>
      }

      @if (showTargetedSection) {
        <h2 
          class="col-start-1 col-span-8">Targeted Events:</h2>
      }
      <div class="col-start-1 col-span-8">
        <div style="max-height: calc(10 * 32px + 32px + 1.5px); overflow: auto;">
          <ag-grid-angular
            #targetedGrid
            class="ag-theme-balham w-full"
            [hidden]="hideGrids()"
            [domLayout]="'autoHeight'"
            [rowData]="data.items"
            [rowHeight]="32"
            [headerHeight]="32"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady()">
          </ag-grid-angular>
        </div>
      </div>

      @if(!hideGrids()) {
        <div class="break col-span-8 col-start-1" style="width: 100%; height: 0.5rem; border-bottom: 1px solid #e9ecf0; margin-bottom: 0.5rem;"></div>
      }

      <div class="col-start-1 col-span-8 grid gap-x-3 gap-y-1 py-1 md:grid-cols-8 md:items-start">
        <mat-radio-group
          [ngModel]="actionTaken()"
          (ngModelChange)="onActionTakenChanged($event)"
          class="contents">
          <div class="md:col-span-4 md:row-span-2 grid auto-rows-min mt-2">
            <div class="flex h-[2em] items-center">
              <mat-radio-button [value]="true">Preferred Action Taken</mat-radio-button>
            </div>

            <div class="flex h-[2em] items-center">
              <mat-radio-button [value]="false">NonActionable (User Defined)</mat-radio-button>
            </div>
          </div>

          <div class="md:col-span-1 flex min-h-[40px] items-center justify-start md:justify-end">
            <span class="mor-dialog-label whitespace-nowrap">Root Cause</span>
          </div>

          <div class="md:col-span-3">
            <app-root-cause-select
              #editRootCauseSelect
              [form]="editDialogForm"
              [label]="''"
              [placeholder]="'Select Root Cause'"
              [multiple]="false"
              [disabled]="rootCauseDisabled()"
              [hideStatusRequiredMessage]="true"
              [dynamicSubscriptSizing]="true"
              [clearEnabled]="true"
              (ready)="onRootCauseReady()"
            (valueChanged)="onRootCauseChanged($event)"></app-root-cause-select>
          </div>

          <div class="md:col-span-1 flex min-h-[40px] items-center justify-start md:justify-end"
            [class.invisible]="!showRcReason"
            [attr.aria-hidden]="!showRcReason">
            <span class="mor-dialog-label whitespace-nowrap">Root Cause Reason*</span>
          </div>

          <div class="md:col-span-3"
            [class.invisible]="!showRcReason"
            [attr.aria-hidden]="!showRcReason">
            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <input matInput
                [formControl]="rcReasonControl"
                [placeholder]="'Type reason here...'">
            </mat-form-field>
          </div>
        </mat-radio-group>
      </div>

      <div class="col-start-1 col-span-8">
        <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
          <mat-label>Notes</mat-label>
          <textarea matInput [formControl]="notesControl" [rows]="3"></textarea>
        </mat-form-field>
      </div>

      <div class="col-start-1 col-span-8">
        <div class="note-history-container">
          @for (note of notesHistory; track note) {
            <div class="note-history-item">
              <p>
                <span class="note-history-user">{{note.User.FirstName[0] + note.User.LastName[0]}} ({{note.Timestamp | date: 'MM/dd/yy'}})</span>
                {{note.Message}}
              </p>
            </div>
          }
        </div>
      </div>

      <!-- NON-TARGETED GRID AND CONTROLS -->
      @if (showTargetedSection) {
        <h2 
          class="col-start-1 col-span-8">Non-Targeted Associated Events:</h2>
        <!-- EVENT COUNT: #### -->
        <div class="col-start-1 col-span-8">
          <span class="flex items-center h-[2em]">Event Count: {{associatedNonTargetedCount}}</span>
        </div>
        <!-- GRID -->
        <div class="col-start-1 col-span-8">
          <div style="max-height: calc(10 * 32px + 32px + 1.5px); overflow: auto;">
            <ag-grid-angular
              #nonTargetedGrid
              class="ag-theme-balham w-full"
              [hidden]="hideGrids()"
              [domLayout]="'autoHeight'"
              [rowHeight]="32"
              [headerHeight]="32"
              [rowData]="associatedNonTargetedRows"
              [columnDefs]="associatedNonTargetedColumnDefs"
              [defaultColDef]="associatedNonTargetedDefaultColDef"
              (gridReady)="onNonTargetedGridReady()">
            </ag-grid-angular>
          </div>
        </div>
        <!-- CHECKBOX TO CLOSE ALL NON-TARGETED EVENTS -->
        <div class="col-start-1 col-span-8 flex items-center gap-1">
          <mat-checkbox
              class="inline"
              [formControl]="closeNonTargetedControl">
            </mat-checkbox>
          <span class="inline">Close all Non-Targeted Events</span>
          <mat-icon 
              class="material-icons-outlined inline" 
              [matTooltip]="closeNonTargetedTooltip" 
              [matTooltipClass]="'app-tooltip'"
              matTooltipPosition="below">info</mat-icon>
        </div>
      }
      
    </div>

  </div>
</div>

<mat-dialog-actions class="flex items-center">
  <div class="mr-auto min-h-[1.25rem] flex items-center"></div>

  <div class="flex items-center gap-2 ml-auto">
    <button mat-flat-button class="secondary-button" mat-dialog-close>Cancel</button>

    <button
      mat-flat-button
      class="primary-button"
      [disabled]="!formReady || editDialogForm.invalid"
      (click)="onSaveClick()">
      Save
    </button>

    @if (data.exportEnabled && batchTypeControl?.value == 'all') {
      <button
        mat-flat-button
        class="primary-button-longtext whitespace-nowrap"
        [disabled]="!formReady || editDialogForm.invalid"
        (click)="onSaveClick(true)">
        Save & Export
      </button>
    }
  </div>
</mat-dialog-actions>
